var map = {
	"./alipay.svg": "e47f",
	"./anquan.svg": "6602",
	"./capital.svg": "e11d",
	"./chart.svg": "2f02",
	"./component.svg": "51c3",
	"./exit-fullscreen.svg": "62d5",
	"./exit.svg": "a2ab",
	"./fold.svg": "0efa",
	"./fullscreen.svg": "379e",
	"./guide.svg": "c228",
	"./info.svg": "76ed",
	"./kline.svg": "26f1",
	"./manage.svg": "54fd",
	"./order.svg": "2965",
	"./peoples.svg": "992b",
	"./renwu.svg": "9d1e",
	"./renwuguanli.svg": "0760",
	"./rolelist.svg": "fb20",
	"./set.svg": "1576",
	"./shangjia-dianji.svg": "01c4",
	"./shouye.svg": "c160",
	"./task.svg": "cee8",
	"./tongji.svg": "8fc5",
	"./xitongguanli.svg": "ed4f",
	"./yonghuguanli.svg": "ae0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";